export default {
  /** 判断当前页面是否tabbar页 */
  get: () => {
    const H5_HEIGHT = 44;
    // 系统信息
    const systemInfo = uni.getSystemInfoSync();
    // 状态栏高度
    const statuBarHeight = systemInfo.statusBarHeight ?? 0;

    let menuButtonInfo: UniNamespace.GetMenuButtonBoundingClientRectRes;
    // 胶囊信息，区分h5和小程序
    // #ifdef MP
    menuButtonInfo = uni.getMenuButtonBoundingClientRect();
    // #endif
    // #ifdef H5
    menuButtonInfo = {
      width: 0,
      right: 0,
      bottom: 0,
      top: 0,
      left: systemInfo.screenWidth,
      height: H5_HEIGHT,
    };
    // #endif

    // 状态栏和胶囊之间的间距
    const diff = menuButtonInfo.top - statuBarHeight;

    // 标题栏高度
    const titleBarHeight = menuButtonInfo.height + diff * 2;

    // 右边距值 小程序下元素不能越过胶囊
    const rightPaddingValue = systemInfo.screenWidth - menuButtonInfo.left;

    return {
      systemInfo,
      statuBarHeight,
      menuButtonInfo,
      titleBarHeight,
      rightPaddingValue,
      totalHeight: titleBarHeight + statuBarHeight,
    };
  },
  setColor: () => {
    uni.setNavigationBarColor({
      frontColor: '#ffffff',
      backgroundColor: '#000000',
      animation: {
        duration: 300,
        timingFunc: 'easeIn',
      },
    });
  },
};
